import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../models/tree-models';

@Component({
  selector: 'app-fs-tree-node',
  templateUrl: './filesystem-tree-node.component.html',
  styleUrls: ['./filesystem-tree-node.component.scss']
})
export class FilesystemTreeNodeComponent {
  @Input() node: TreeNode;
  @Output() nodesHandler: EventEmitter<TreeNode> = new EventEmitter<TreeNode>();
  @Output() dropHandler = new EventEmitter<any>();

  nodesEmitter = (node: TreeNode) => this.nodesHandler.emit(node);

  shouldShowIcon(node: TreeNode): boolean {
    return node.type === 'folder' && node.children && node.children.some((child) => child.type === 'folder');
  }

  toggleNode(node: TreeNode) {
    if (this.shouldShowIcon(node)) {
      node.expanded = !node.expanded;
    }
  }

  onDragOver = ($event: DragEvent) => {
    $event.preventDefault();
    $event.dataTransfer.dropEffect = 'move';
  };

  onDrop = (node: DragEvent, elementDroped: any) => {
    this.dropHandler.emit({ node, elementDroped });
  };
}
